const sortOptionList = (optionList: Record<string, any>) => {
  if (!optionList) {
    return;
  }

  optionList?.forEach((facetList) => {
    if (facetList.searchFacetOptionGroupList) {
      sortOptionList(facetList.searchFacetOptionGroupList);
    }
  });

  const sortOrder = [
    'regular',
    'tall',
    'petite',
    'maternity',
    'husky',
    'slim',
    'preemie',
    'plus',
    'infant',
    'youth',
    'toddler',
    'big',
    'standard',
    'curvy',
    'one size'
  ];

  optionList?.sort(({ searchFacetOptionGroupName: a }, { searchFacetOptionGroupName: b }) => {
    if (sortOrder.indexOf(a?.toLowerCase()) > sortOrder.indexOf(b?.toLowerCase())) {
      return 1;
    } else if (sortOrder.indexOf(b?.toLowerCase()) > sortOrder.indexOf(a?.toLowerCase())) {
      return -1;
    }
    return 0;
  });
};

export const sortForSizeGroups = (data: Record<string, any>) => {
  const searchFacetList = data?.productCategoryFacetedSearch?.searchFacetInfo?.searchFacetList;
  const sizeSearchFacetList = searchFacetList?.filter(facet => facet.searchFacetId === 'size');
  sizeSearchFacetList?.forEach(facetList => sortOptionList(facetList.searchFacetOptionGroupList));
};
